import {
  Box,
  useTheme,
  Text,
  Skeleton,
  Button,
  Flex,
  InputGroup,
  InputRightElement,
  Icon,
} from "@chakra-ui/react";
import React from "react";
import { Theme } from "../../theme";
import getAxios from "../../hooks/useAxios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { FaArrowRight } from "react-icons/fa";
import { MdArrowBackIosNew, MdArrowForwardIos, MdSearch } from "react-icons/md";
import Input from "../../components/CustomInput";

let percentage = 15;
function UpcomingPayment() {
  const theme = useTheme<Theme>();
  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");
  const [allDrivers, setAllDrivers] = React.useState<any>([]);
  const [pageNumber, setPageNumber] = React.useState(() => {
    return Number(localStorage.getItem("upcomingpage")) || 1;
  });
  const [totalPages, setTotalPages] = React.useState<number>();
  const [totalDrivers, setTotalDrivers] = React.useState<string>();
  const [isDataFetching, setIsDataFetching] = React.useState(true);
  const [nextNotAllowed, setNextNotAllowed] = React.useState(false);
  const [refetchUrl, setRefetchUrl] = React.useState(
    "/drivers?status=approved&blocked=false&recent_earnings=true&page=1",
  );
  const [searchName, setSearchName] = React.useState("");
  const [searchMobile, setSearchMobile] = React.useState("");
  const [researchData, setResearchData] = React.useState<string>();

  const getAllDrivers = async (url: string) => {
    setIsDataFetching(true);
    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("all drivers", res.data);
      setAllDrivers(res.data.data);
      setTotalPages(res.data.pagination.totalPages);
      setTotalDrivers(res.data.pagination.total);
      if (res.data.length < 20) {
        setNextNotAllowed(true);
      } else {
        setNextNotAllowed(false);
      }
    } catch (error) {
      console.log("error listing drivers", error);
    } finally {
      setIsDataFetching(false);
    }
  };

  const handleSearchData = (val: string) => {
    if (val === "name") {
      if (searchName !== "") {
        getAllDrivers(
          `/drivers?status=approved&blocked=false&recent_earnings=true&name=${searchName}`,
        );
      } else {
        getAllDrivers(refetchUrl);
      }
    } else {
      if (searchMobile !== "") {
        getAllDrivers(
          `/drivers?status=approved&blocked=false&recent_earnings=true&mobile=${searchMobile}`,
        );
      } else {
        getAllDrivers(refetchUrl);
      }
    }
  };

  React.useEffect(() => {
    getAllDrivers(
      `/drivers?status=approved&blocked=false&recent_earnings=true&page=${pageNumber}`,
    );
  }, [pageNumber, researchData]);

  React.useEffect(() => {
    if (totalPages && totalPages === pageNumber) {
      setNextNotAllowed(true);
    } else {
      setNextNotAllowed(false);
    }
  }, [totalPages]);

  return (
    <Box sx={{ height: "100%", width: "100%", padding: "0 1rem" }}>
      <Text
        sx={{
          fontSize: theme.fontSizes.subHeading1,
          margin: "2.5rem 0 2rem 2rem",
        }}
      >
        Recent Earning Drivers (Last 10 Days)
      </Text>

      <Flex
        sx={{
          gap: "1rem",
          paddingLeft: "2rem",
          marginBottom: "2rem",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Flex sx={{ gap: "1rem" }}>
          <Box sx={{ height: "100%" }}>
            <InputGroup>
              <InputRightElement
                h="100%"
                cursor={"pointer"}
                onClick={() => handleSearchData("name")}
              >
                <MdSearch color={theme.colors.secondary.main} size={20} />
              </InputRightElement>
              <Input
                variant={"outline"}
                placeholder="Search by name"
                sx={{
                  height: "100%",
                }}
                borderColor={theme.colors.secondary.main}
                onChange={(e) => {
                  if (e.target.value !== "") {
                    setSearchName(e.target.value);
                  } else {
                    setResearchData(`again_${Math.random()}`);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearchData("name");
                  }
                }}
              />
            </InputGroup>
          </Box>

          <Box sx={{ height: "100%" }}>
            <InputGroup>
              <InputRightElement
                h="100%"
                cursor={"pointer"}
                onClick={() => handleSearchData("mobile")}
              >
                <MdSearch color={theme.colors.secondary.main} size={20} />
              </InputRightElement>
              <Input
                variant={"outline"}
                placeholder="Search by number"
                sx={{
                  height: "100%",
                }}
                borderColor={theme.colors.secondary.main}
                onChange={(e) => {
                  if (e.target.value !== "") {
                    setSearchMobile(e.target.value);
                  } else {
                    setResearchData(`again_${Math.random()}`);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearchData("mobile");
                  }
                }}
              />
            </InputGroup>
          </Box>
        </Flex>

        <Flex sx={{ marginRight: "3vw" }}>
          <Text
            sx={{
              fontSize: theme.fontSizes.body,
              marginRight: "0.25rem",
            }}
          >
            Total Upcoming Payments:
          </Text>
          <Skeleton isLoaded={!isDataFetching}>
            <Text
              sx={{
                fontSize: theme.fontSizes.body,
                color: "green",
              }}
            >
              {totalDrivers}
            </Text>
          </Skeleton>
        </Flex>
      </Flex>

      <Box sx={{ marginTop: "1rem", paddingX: "2rem" }}>
        <Skeleton isLoaded={isDataFetching ? false : true} minHeight={"20rem"}>
          {allDrivers.length !== 0 ? (
            <Skeleton
              isLoaded={allDrivers ? true : false}
              minWidth={"580px"}
              width={"74vw"}
            >
              <ViewersTable data={allDrivers} theme={theme} />
            </Skeleton>
          ) : (
            <Text>No data available</Text>
          )}
        </Skeleton>
        <Box
          sx={{
            marginTop: theme.space.xl,
          }}
        >
          <Flex
            sx={{
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "3rem",
            }}
          >
            <Box>
              <Flex
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Flex
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    width: "2rem",
                    height: "2rem",
                  }}
                >
                  <Icon
                    as={MdArrowBackIosNew}
                    boxSize={5}
                    color={theme.colors.primary.main}
                    cursor={pageNumber !== 1 ? "pointer" : "not-allowed"}
                    onClick={() => {
                      if (pageNumber !== 1) {
                        setPageNumber(pageNumber - 1);
                        localStorage.setItem(
                          "upcomingpage",
                          `${pageNumber - 1}`,
                        );
                        setRefetchUrl(
                          `/drivers?status=approved&blocked=false&recent_earnings=true&page=${
                            pageNumber - 1
                          }`,
                        );
                      }
                    }}
                  />
                </Flex>
                <Text variant={"caption"}>Previous Page</Text>
              </Flex>
            </Box>
            <Skeleton
              isLoaded={isDataFetching ? false : true}
              sx={{ width: "2rem" }}
            >
              <Text variant={"body"}>{pageNumber}</Text>
            </Skeleton>
            <Box>
              <Flex
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Text variant={"caption"}>Next Page</Text>
                <Flex
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    width: "2rem",
                    height: "2rem",
                  }}
                >
                  <Icon
                    as={MdArrowForwardIos}
                    boxSize={5}
                    color={theme.colors.primary.main}
                    cursor={nextNotAllowed ? "not-allowed" : "pointer"}
                    onClick={() => {
                      if (!nextNotAllowed) {
                        setPageNumber(pageNumber + 1);
                        localStorage.setItem(
                          "upcomingpage",
                          `${pageNumber + 1}`,
                        );
                        setRefetchUrl(
                          `/drivers?status=approved&blocked=false&recent_earnings=true&page=${
                            pageNumber + 1
                          }`,
                        );
                      }
                    }}
                  />
                </Flex>
              </Flex>
            </Box>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
}

export default UpcomingPayment;

type ViewerstableType = {
  data?: any;
  theme: Theme;
};

function ViewersTable({ data, theme }: ViewerstableType) {
  const navigate = useNavigate();
  const removeExtraPaddingStyle = {
    WebkitPaddingStart: 0,
    paddingInlineStart: 0,
    WebkitPaddingEnd: 0,
    paddingInlineEnd: "1rem",
  };
  return (
    <div style={{ overflowX: "auto", maxWidth: "100%" }}>
      <table style={{ minWidth: "800px" }}>
        <thead>
          <tr>
            <th style={{ ...removeExtraPaddingStyle, paddingLeft: "1rem" }}>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Sl. No.
              </Text>
            </th>

            <th style={{ ...removeExtraPaddingStyle, paddingLeft: "1rem" }}>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Vehicle Reg. No.
              </Text>
            </th>
            <th style={removeExtraPaddingStyle}>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Name
              </Text>
            </th>
            <th style={removeExtraPaddingStyle}>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Mobile
              </Text>
            </th>
            <th style={removeExtraPaddingStyle}>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Payment Status
              </Text>
            </th>
            <th style={removeExtraPaddingStyle}>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Payment Due Date
              </Text>
            </th>
            <th style={removeExtraPaddingStyle}>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Payable Amount
              </Text>
            </th>
            <th style={removeExtraPaddingStyle}></th>
          </tr>
        </thead>
        <tbody>
          {data.map((item: any, index: number) => (
            <tr key={index}>
              <td style={{ ...removeExtraPaddingStyle, paddingLeft: "1rem" }}>
                <Text
                  sx={{
                    fontSize: theme.fontSizes.body,
                  }}
                >
                  {index + 1}
                </Text>
              </td>

              <td style={{ ...removeExtraPaddingStyle, paddingLeft: "1rem" }}>
                <Text
                  sx={{
                    fontSize: theme.fontSizes.body,
                  }}
                >
                  {item.vehicle_details?.registration_number || "N/A"}
                </Text>
              </td>
              <td style={removeExtraPaddingStyle}>
                <Text
                  sx={{
                    fontSize: theme.fontSizes.body,
                  }}
                >
                  {item.name}
                </Text>
              </td>
              <td style={removeExtraPaddingStyle}>
                <Text
                  sx={{
                    fontSize: theme.fontSizes.body,
                  }}
                >
                  {item.mobile}
                </Text>
              </td>
              <td style={removeExtraPaddingStyle}>
                <GetPaymentStatus item={item} />
              </td>
              <td style={removeExtraPaddingStyle}>
                <GetDueDate item={item} />
              </td>
              <td style={removeExtraPaddingStyle}>
                <GetPaymentAmount item={item} />
              </td>
              <td style={removeExtraPaddingStyle}>
                <Flex
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    height: "2.8rem",
                    borderRadius: "0.25rem",
                  }}
                >
                  <Button
                    width="100%"
                    height="3rem"
                    rightIcon={<FaArrowRight />}
                    onClick={() => {
                      navigate({
                        pathname: "/drivers/details",
                        search: `?id=${item.id}`,
                      });
                    }}
                    style={{
                      background: theme.colors.primary.main,
                      color: theme.colors.bg.main,
                    }}
                  >
                    <Text sx={{ fontSize: theme.fontSizes.body }}>
                      {"View Details"}
                    </Text>
                  </Button>
                </Flex>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const GetDueDate = ({ item }: any) => {
  const theme = useTheme<Theme>();
  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");
  const [totalEarnings, setTotalEarnings] = React.useState<any>();
  const [loading, setLoading] = React.useState(true);

  async function getAllEarning() {
    try {
      const res = await axios.get(`/incomes?driver_id=${item.id}`);
      setTotalEarnings(res.data);
    } catch (error) {
      console.log("error incomes", error);
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    getAllEarning();
  }, []);

  return (
    <Skeleton isLoaded={loading ? false : true} minH={"2rem"}>
      <Text
        sx={{
          fontSize: theme.fontSizes.body,
        }}
      >
        {totalEarnings?.current_end &&
          new Date(totalEarnings?.current_end).toDateString()}
      </Text>
    </Skeleton>
  );
};

const GetPaymentAmount = ({ item }: any) => {
  const theme = useTheme<Theme>();
  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");
  const [totalEarnings, setTotalEarnings] = React.useState<any>();
  const [loading, setLoading] = React.useState(true);

  async function getAllEarning() {
    try {
      const res = await axios.get(`/incomes?driver_id=${item.id}`);
      setTotalEarnings(res.data);
    } catch (error) {
      console.log("error incomes", error);
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    getAllEarning();
  }, []);

  return (
    <Skeleton isLoaded={loading ? false : true} minH={"2rem"}>
      <Text
        sx={{
          fontSize: theme.fontSizes.body,
        }}
      >
        ₹
        {totalEarnings?.current_income &&
          ((percentage / 100) * totalEarnings?.current_income).toFixed(2)}
      </Text>
    </Skeleton>
  );
};

const GetPaymentStatus = ({ item }: any) => {
  const theme = useTheme<Theme>();
  const axios = getAxios();
  const [loading, setLoading] = React.useState(true);
  const [paymentOverdue, setPaymentOverdue] = React.useState<any>();

  async function getAllEarning() {
    try {
      const res = await axios.get(`/incomes?driver_id=${item.id}`);
      if (item.is_payment_overdue) {
        setPaymentOverdue(true);
      } else {
        const amount =
          res.data.current_income &&
          Number(((percentage / 100) * res.data.current_income).toFixed(2));
        if (amount === 0) {
          setPaymentOverdue(false);
        } else {
          const sysdate = new Date();
          const driverDate = new Date(res.data.current_end);
          const isPast = driverDate < sysdate;
          setPaymentOverdue(isPast);
        }
      }
    } catch (error) {
      console.log("error incomes", error);
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    getAllEarning();
  }, []);

  return (
    <Skeleton isLoaded={loading ? false : true} minH={"2rem"}>
      <Text
        sx={{
          fontSize: theme.fontSizes.body,
        }}
        color={paymentOverdue ? theme.colors.error : theme.colors.success}
      >
        {paymentOverdue ? "Pending" : "Cleared"}
      </Text>
    </Skeleton>
  );
};
